/**
 * Maps a stored country value ('US', 'CA', 'Canada', 'United States', ...) to the code RegionSelect and the postal/tax
 * validators key on. Anything unrecognised is left upper-cased so RegionSelect falls back to free text; empty means US.
 */
export function regionCountryCode(raw: unknown): string {
  const c = String(raw ?? '').trim().toUpperCase();
  if (!c) return 'US';
  if (c === 'US' || c === 'USA' || c === 'UNITED STATES' || c === 'UNITED STATES OF AMERICA') return 'US';
  if (c === 'CA' || c === 'CAN' || c === 'CANADA') return 'CA';
  return c;
}
